import * as React from 'react';
import { Row, Col, Grid } from 'react-flexbox-grid';
import { InjectedIntlProps, injectIntl, FormattedMessage } from 'react-intl';
import { Person } from '../../../types';
import Page from '../../../components/page';
import UnloadHandler from '../../../components/unload-handler';
import Steps from '../../../patterns/molecules/steps';
import Header from '../../../patterns/molecules/header';
import LegalRepresentativeForm from '../../../patterns/molecules/legal-representative-form';
import VerticalDivider from '../../../patterns/atoms/vertical-divider';
import Sidebar from '../../../patterns/molecules/sidebar';
import Button from '../../../patterns/atoms/button';
import { ReactComponent as BackIcon } from '../../../patterns/atoms/icons/back.svg';
import defaultSteps from '../../../models/steps';
import SidebarCheckList from '../../../patterns/atoms/sidebar-check-list';
import { LEGAL_REPRESENTATIVE_FORM } from '../../legalRepresentative/models/legal-representative';
import { config as businessInfoConfig } from '../../businessInfo';
import { config as businessLegalRepresentativeConfig } from '../../businessLegalRepresentative';
import { ReactComponent as LegalRepIcon } from '../../../patterns/atoms/icons/legalrep.svg';

interface BusinessLegalRepresentativePersonsProps extends InjectedIntlProps {
  submit: Function;
  client: Person;
  business_name: string;
  hasBusinessAsLegalRep: boolean;
}

class BusinessLegalRepresentativePersons extends React.PureComponent<BusinessLegalRepresentativePersonsProps, {}> {
  submitForm = () => {
    this.props.submit(LEGAL_REPRESENTATIVE_FORM);
  };

  public render(): JSX.Element {
    const {
      client,
      intl: { formatMessage },
      hasBusinessAsLegalRep,
      business_name,
    } = this.props;
    const previousUrl = hasBusinessAsLegalRep
      ? businessLegalRepresentativeConfig.routes.businessLegalRepresentative.path
      : businessInfoConfig.routes.businessInfo.path;
    return (
      <Page
        header={
          <Header
            sidebar={
              <Button fullWidth={true} variant="primary" handleClick={this.submitForm}>
                <FormattedMessage id="pages.next_step" />
              </Button>
            }
          >
            <Steps active={2} steps={defaultSteps} />
          </Header>
        }
      >
        <Grid fluid={true}>
          <Row between="xs">
            <Col sm={2}>
              <Button href={previousUrl} display="inline">
                <BackIcon />
                <FormattedMessage id="pages.back" />
              </Button>
            </Col>
            <Col sm={6}>
              <h2>{formatMessage({ id: 'forms.legal_representative.title' }, { name: client.first_name })}</h2>
              <LegalRepresentativeForm client={client} />
            </Col>
            <Col sm={1}>
              <VerticalDivider />
            </Col>
            <Col sm={3}>
              <Sidebar
                title={formatMessage(
                  {
                    id: 'pages.business_legal_representative_persons.sidebar.title',
                  },
                  { business_name },
                )}
                icon={<LegalRepIcon />}
                content={formatMessage({
                  id: 'pages.business_legal_representative_persons.sidebar.content',
                })}
              >
                <SidebarCheckList>
                  <FormattedMessage id="pages.business_legal_representative_persons.sidebar.point1" />
                </SidebarCheckList>
                <SidebarCheckList>
                  <FormattedMessage id="pages.business_legal_representative_persons.sidebar.point2" />
                </SidebarCheckList>
                <SidebarCheckList>
                  <FormattedMessage id="pages.business_legal_representative_persons.sidebar.point3" />
                </SidebarCheckList>
                <SidebarCheckList>
                  <FormattedMessage id="pages.business_legal_representative_persons.sidebar.point4" />
                </SidebarCheckList>
                <Button href="info/faq-legal-representatives" display="inline" variant="primary" bold={true}>
                  <FormattedMessage id="pages.legal_representative.legal_representatives_faq" />
                </Button>
              </Sidebar>
            </Col>
          </Row>
        </Grid>
        <UnloadHandler />
      </Page>
    );
  }
}

export default injectIntl(BusinessLegalRepresentativePersons);
